export default __webpack_public_path__ + "static/media/empty-saved-queries.f2f559ff.svg";